import { axios } from '@Root/API'

export const remove = feesId => {
	return axios.delete(`fee-details/${feesId}`)
}
